import { Box } from "@mui/material";
import React from "react";
import BasicPage from "./BasicPage";
import { Outlet } from "react-router-dom";

export default function Approval() {
	return (
		<Box>
			<BasicPage />
            <Outlet/>
		</Box>
	);
}
